import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import { styled, alpha } from '@mui/material';

import Tabs from 'components/shared/Tabs';
import { useTranslation } from 'react-i18next';

const TopNavigation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const tabs = [
    {
      path: '/on-tap',
      label: t('layouts.onTap'),
    },
    {
      path: '/inventory',
      label: t('layouts.inventory'),
    },
  ];

  const match =
    ['/on-tap', '/inventory', '/inventory/cooler', '/inventory/ordering'].includes(
      location.pathname,
    ) && !Boolean(location?.state?.id);

  return (
    <StyledRootBox className="top_navigation" sx={{ visibility: match ? 'visible' : 'hidden' }}>
      <Tabs isNativeView tabs={tabs} isNavTabs className="tabs" isFullWidth />
    </StyledRootBox>
  );
};

export default TopNavigation;

const StyledRootBox = styled(Box)(({ theme }) => ({
  boxShadow: 'none',
  width: '100%',
  '& .MuiTouchRipple-child': {
    backgroundColor: alpha(theme.palette.white, 0.5),
  },
}));
